var _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSandwich(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 2,
    rx: 1,
    fill: "url(#paint0_linear_99_8775)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 12,
    height: 2,
    rx: 1,
    fill: "url(#paint1_linear_99_8775)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 16,
    height: 2,
    rx: 1,
    fill: "url(#paint2_linear_99_8775)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_8775",
    x1: 0,
    y1: 1,
    x2: 20,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69D5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_8775",
    x1: 0,
    y1: 8,
    x2: 12,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69D5EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_8775",
    x1: 0,
    y1: 15,
    x2: 16,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72E9AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69D5EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandwich);
export default __webpack_public_path__ + "static/media/sandwich.2e95e498c6684823e6a14f3b6516a71d.svg";
export { ForwardRef as ReactComponent };